import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './LoginRegisterPopup.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import IconClosePrimary from '../../components/atoms/Icons/IconClosePrimary';
import RouterLink from '../atoms/RouterLink';
import { canUseDOM, getGlobalDictionaryTerm } from '../../utils';
import Cookies from 'js-cookie';
import { get, getDictionaryItem } from '../../utils';
var LoginRegisterPopup = function LoginRegisterPopup(_ref) {
  var dictionary = _ref.dictionary,
    accountLinks = _ref.accountLinks,
    videoPopup = _ref.videoPopup;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loginLinkState = _React$useState2[0],
    setLoginLinkState = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    registerLinkState = _React$useState4[0],
    setRegisterLinkState = _React$useState4[1];
  var loginPopupCookieName = 'login_popup';
  var linksArray = get(accountLinks, 'targetItem.links');
  var Login = linksArray && linksArray[2];
  var Register = linksArray && linksArray[4];
  // const dictionaryValues: any = { dictionaryValues: [...dictionary] };
  var popupHeading = videoPopup ? getDictionaryItem(dictionary && dictionary.dictionary, 'LoginVideoPopupTitle') : getDictionaryItem(dictionary && dictionary.dictionary, 'LoginPopupTitle');
  var popupCopy = videoPopup ? getDictionaryItem(dictionary && dictionary.dictionary, 'LoginVideoPopupDetails') : getDictionaryItem(dictionary && dictionary.dictionary, 'LoginDetails');
  var popupLoginTitle = videoPopup ? getDictionaryItem(dictionary && dictionary.dictionary, 'LoginVideoPopupButtonTitle') : get(Login, 'title.jss.value');
  var popupRegisterTitle = videoPopup ? getDictionaryItem(dictionary && dictionary.dictionary, 'LoginVideoPopupRegisterButtonTitle') : get(Register, 'title.jss.value');
  var closeText = getGlobalDictionaryTerm(sitecoreContext, 'close') || "Close";
  var processClick = function processClick() {
    if (canUseDOM) {
      document.body.classList.remove('lr-popup--open');
      document.body.classList.remove('lr-popup--video--open');
    }
    Cookies.set(loginPopupCookieName, JSON.stringify({
      processed: 'true'
    }), {
      expires: 999,
      secure: true
    });
  };
  React.useEffect(function () {
    var referBackUrl = '';
    if (canUseDOM) {
      referBackUrl = window.location.href;
      if (referBackUrl.indexOf('?') !== -1) {
        referBackUrl = referBackUrl.substr(0, referBackUrl.indexOf('?'));
      }
    }
    var loginLink = get(Login, 'link.jss.value.href') + "?redirect_url=".concat(referBackUrl);
    var registerLink = get(Register, 'link.jss.value.href') + "?redirect_url=".concat(referBackUrl);
    setLoginLinkState(loginLink);
    setRegisterLinkState(registerLink);
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "rs_skip ".concat(videoPopup ? 'lr-popup--video' : 'lr-popup')
  }, /*#__PURE__*/React.createElement("button", {
    className: "lr-popup__close btn--reset",
    onClick: processClick,
    "aria-label": closeText
  }, /*#__PURE__*/React.createElement("span", {
    hidden: true
  }, closeText), /*#__PURE__*/React.createElement(IconClosePrimary, null)), popupHeading && /*#__PURE__*/React.createElement("h2", {
    className: "h4 lr-popup__title"
  }, popupHeading), /*#__PURE__*/React.createElement("p", {
    className: "body-medium lr-popup__copy"
  }, popupCopy), !!popupLoginTitle && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary",
    href: loginLinkState,
    onClick: processClick
  }, popupLoginTitle), !!popupRegisterTitle && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-secondary",
    href: registerLinkState,
    onClick: processClick
  }, popupRegisterTitle)));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStyles)
  }, children);
};
var commonStyles = "c55dpy1";
var ltrStyles = "lp94ygm";
var rtlStyles = "r6d6a80";
export default LoginRegisterPopup;